import { EventEmitter, Input, OnChanges, Output } from "@angular/core";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Table, TableModule } from "primeng/table";
import { CommissionPaidTotalRequestDto } from "../../../../core/models/bcLedgers/commissionPaidTotalRequestDto";
import { CommissionPaidTotalData } from "../../../../core/models/bcLedgers/commissionPaidTotalResponseDto";
import { CommonModule } from "@angular/common";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { BcLedgerStacker } from "../../../../core/models/bcLedgers/bcLedgerStacker";
import { LoaderService } from "../../../../core/services/loader.service";
import { exportExcel } from "../../../../core/services/shared.service";
import { HidedynamicsdatePipe } from "../../../../shared/pipes/hidedate/hidedynamicsdate.pipe";
import { BcledgerService } from "../../../../core/services/bcledger.service";
import { InputTextModule } from "primeng/inputtext";
import { ButtonModule } from "primeng/button";

@Component({
  selector: "jni-commissions-paid-total",
  templateUrl: "./commissions-paid-total.component.html",
  styleUrls: ["./commissions-paid-total.component.scss"],
  imports: [
    TableModule,
    CommonModule,
    HidedynamicsdatePipe,
    InputTextModule,
    ButtonModule,
  ],
})
export class CommissionsPaidTotalComponent implements OnInit, OnChanges {
  @Input() bcLedgerStacker!: BcLedgerStacker;
  commissionsPaidTotalParams!: CommissionPaidTotalRequestDto;
  commissionsPaidTotalList: CommissionPaidTotalData[] = [];
  total!: number;
  fileName = "Commission Paid Total";
  @Output() closeModalEvent = new EventEmitter();

  constructor(
    private _activatedRoute: ActivatedRoute,
    private _toastrService: JniToastrService,
    private _loaderService: LoaderService,
    private _commissionsPaidTotalService: BcledgerService
  ) {
    this._activatedRoute.params.subscribe(params => {
      this.commissionsPaidTotalParams = {
        ...params,
      } as CommissionPaidTotalRequestDto;
    });
  }

  ngOnInit(): void {
    this.getCommissionPaidTotal(this.commissionsPaidTotalParams);
  }

  getCommissionPaidTotal(payload: CommissionPaidTotalRequestDto) {
    this._loaderService.setLoaderState(true);
    this._commissionsPaidTotalService.commissionPaidTotal(payload).subscribe({
      next: res => {
        this._loaderService.setLoaderState(false);
        if (res.data) {
          this.commissionsPaidTotalList = res.data.Data ?? [];
          this.total = res.data.Total;
          return;
        }
        this._toastrService.error(res.message ?? "No results found", "Error");
      },
      error: () => {
        this._loaderService.setLoaderState(false);
        this._toastrService.error("No results found", "Error");
      },
    });
  }

  clearTable(table: Table) {
    table.clear();
  }

  exportExcelFile() {
    exportExcel(this.commissionsPaidTotalList, this.fileName);
  }

  ngOnChanges() {
    if (this.bcLedgerStacker) {
      this.commissionsPaidTotalParams = { ...this.bcLedgerStacker };
    }
  }

  onCloseModalEvent() {
    this.closeModalEvent.emit();
  }
}
